import { type MaybeRefOrGetter } from 'vue'
import type { SharedPaginationOptions } from '@/shared/types'
import type { ComposableOptions } from '@/types'

export const invoiceQueryKeys = {
  all() {
    return ['invoices'] as const
  },

  activityLog(invoiceId: MaybeRefOrGetter<number>) {
    return [...invoiceQueryKeys.all(), 'activity-log', invoiceId] as const
  },

  template(assetCode: MaybeRefOrGetter<string>) {
    return [...invoiceQueryKeys.all(), 'template', assetCode] as const
  },

  details(invoiceId: MaybeRefOrGetter<number>) {
    return [...invoiceQueryKeys.all(), 'details', invoiceId] as const
  },

  invoice(invoiceId: MaybeRefOrGetter<number>){
    return [...invoiceQueryKeys.all(),invoiceId] as const
  },

  invoiceMeterReadings(invoiceId: MaybeRefOrGetter<number>) {
    return [...invoiceQueryKeys.all(), 'meter readings', invoiceId] as const
  },

  paginated<T extends ComposableOptions<SharedPaginationOptions>>(options?: T) {
    return [...invoiceQueryKeys.all(), 'paginated', ...(options === undefined ? [] : [options])] as const
  }
} as const

export const creditNoteQueryKeys = {
  all() {
    return ['credit-notes'] as const
  },

  allocatable(invoiceId?: MaybeRefOrGetter<number>) {
    return invoiceId
      ? [...creditNoteQueryKeys.all(), 'applicable', invoiceId]
      : [...creditNoteQueryKeys.all(), 'applicable']
  },

  details(creditNoteIdOrIds?: MaybeRefOrGetter<number|number[]>) {
    return creditNoteIdOrIds
      ? [...creditNoteQueryKeys.all(), 'details', creditNoteIdOrIds]
      : [...creditNoteQueryKeys.all(), 'details']
  }
}
